<template>
    <div v-hammer:swipe="onSwipe" class="product-gallery">
        <div class="grid-wrap">
            <!-- stage -->
            <div @click="openGallery" class="stage">
                <transition name="fade">
                    <super-image
                        :src="activeSrc"
                        :key="activeSrc"
                        color="#f1f1f1"
                        fill-space
                    />
                </transition>
            </div>

            <!-- thumbs -->
            <button
                @click="activeIdx = i"
                class="thumb reset"
                v-for="(src, i) in limitedImages"
            >
                <super-image :src="src" color="#f1f1f1" fill-space />
            </button>
        </div>

        <!-- pagination -->
        <div v-if="limitedImages.length > 1" class="pagination">
            <span
                :class="['dot', { active: i === activeIdx }]"
                v-for="(src, i) in limitedImages"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: Array
    },
    data() {
        return {
            activeIdx: 0
        }
    },
    computed: {
        activeSrc() {
            return this.cleanImages[this.activeIdx]
        },
        cleanImages() {
            const images = this.images || []
            return images.map(s => s.trim()).filter(Boolean)
        },
        limitedImages() {
            return this.cleanImages.slice(0, 6)
        }
    },
    methods: {
        onSwipe(e) {
            if (e.direction === 2) this.goNext()
            else if (e.direction === 4) this.goPrev()
            else return true
        },
        goNext() {
            this.activeIdx = (this.activeIdx + 1) % this.limitedImages.length
        },
        goPrev() {
            let prevIdx = this.activeIdx - 1
            if (prevIdx < 0) prevIdx = this.limitedImages.length - 1
            this.activeIdx = prevIdx
        },
        openGallery() {
            this.$store.dispatch('OPEN_GALLERY', {
                images: this.limitedImages,
                index: this.activeIdx
            })
        }
    }
}
</script>

<style lang="scss">
@import 'src/scss/mixins';

.product-gallery {
    position: relative;
    padding-bottom: 106%;
    margin-bottom: 30px; /* For pagination */
    height: 0;

    .grid-wrap {
        grid-template-columns: repeat(6, 1fr) 12.5%;
        grid-template-rows: repeat(6, 1fr);
        grid-gap: 20px;
        display: grid;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .stage {
        position: relative;
        grid-column: span 6;
        grid-row: span 6;
        cursor: pointer;
    }
    .thumb {
        position: relative;
        background-color: #f1f1f1;
    }

    // mobile pagination
    .pagination {
        text-align: center;
        position: absolute;
        display: none;
        right: 15px;
        left: 15px;
        top: calc(100% + 17px);

        .dot {
            transition: background 200ms;
            background-color: rgba($red, 0.5);
            display: inline-block;
            border-radius: 100%;
            height: 10px;
            width: 10px;
        }
        .dot.active {
            background-color: $red;
        }
    }

    // transition
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 250ms;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    // mobile
    @include bp(s) {
        .grid-wrap {
            display: block;
        }
        .stage {
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;
            top: 0;
        }
        .thumb {
            display: none;
        }
        .pagination {
            display: block;
        }
    }
}
</style>
